var PubSubObserver = /** @class */function () {
  function PubSubObserver() {
    this.subscriptions = [];
  }
  PubSubObserver.prototype.publish = function (signal) {
    this.subscriptions.forEach(function (subscription) {
      try {
        if (signal.type === subscription.query.type) {
          subscription.onSignal(signal);
        }
      } catch (e) {
        if (typeof subscription.onError === 'function') {
          subscription.onError(e, signal);
        }
      }
    });
  };
  PubSubObserver.prototype.subscribe = function (subscription) {
    if (!this.subscriptions.includes(subscription)) {
      this.subscriptions.push(subscription);
    }
  };
  PubSubObserver.prototype.unsubscribe = function (subscription) {
    this.subscriptions = this.subscriptions.filter(function (subscribedElement) {
      return subscription !== subscribedElement;
    });
  };
  return PubSubObserver;
}();
export var PubSubEventManager = new PubSubObserver();